var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUkFlag = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 32,
    viewBox: "0 0 49 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.921 32H0.840759C0.376475 32 0 31.6229 0 31.1579V0.842142C0 0.377094 0.376475 0 0.840759 0H47.9211C48.3853 0 48.7618 0.377094 48.7618 0.842142V31.1579C48.7617 31.6229 48.3852 32 47.921 32Z",
    fill: "#41479B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7617 0.842142C48.7617 0.377094 48.3852 0 47.921 0H44.1595L28.5844 10.2212V0H20.1772V10.2212L4.60208 0H0.840759C0.376475 0 0 0.377094 0 0.842142V3.0201L13.3627 11.7894H0V20.2105H13.3627L0 28.9799V31.1579C0 31.6229 0.376475 32 0.840759 32H4.60217L20.1774 21.7788V32H28.5846V21.7788L44.1597 32H47.9211C48.3854 32 48.7619 31.6229 48.7619 31.1579V28.9799L35.3992 20.2106H48.7617V11.7895H35.399L48.7617 3.0201V0.842142Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7617 13.4737H26.903V0H21.8587V13.4737H0V18.5263H21.8587V32H26.903V18.5263H48.7617V13.4737Z",
    fill: "#FF4B55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0426 20.2104L0.0238037 31.2759C0.0833273 31.6826 0.418088 32 0.840658 32H1.99865L20.131 20.2105H17.0426V20.2104V20.2104Z",
    fill: "#FF4B55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9892 20.2104H29.9009L48.0068 31.9825C48.4288 31.9375 48.7619 31.5924 48.7619 31.1577V30.4654L32.9892 20.2104Z",
    fill: "#FF4B55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.77178L15.4075 11.7895H18.4958L0.489808 0.0821533C0.20219 0.215992 0 0.503606 0 0.842161V1.77178Z",
    fill: "#FF4B55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6728 11.7902L48.7325 0.697971C48.6616 0.304755 48.334 0.000732422 47.921 0.000732422H46.7165L28.5845 11.7902H31.6728Z",
    fill: "#FF4B55"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUkFlag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/uk-flag.b60a402f.svg";
export { ForwardRef as ReactComponent };